export const COLORS = {
  accentRed: '#EB5757',
  red: '#EB5757',
  secondaryNavy1: '#456772',
  primary: '#DAEFED',
  primaryNavy: '#183F4F',
  secondary: '#6D9147',
  ivory: '#FFFFF0',
  secondaryNavy2: '#7C989B',
  borderNavy: '#90e0ee',
};
